module.exports = __webpack_public_path__ + "static/cdp-map-44a1d9c8badb4a1717e4ceb87f43f6fc.png";